angular.module("ainapp")
    .controller("addOpeningStockController", ["app.config", "$scope", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Add Opening Stock";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.getOpeningStockbyId(data).then(function (response) {
                    $scope.OpeningStock = response.data[0];
                    $scope.AccountNumber = $scope.OpeningStock.VoucherNo;
                    $scope.OpeningStock.Date = new Date(response.data[0].Date);

                    angular.forEach($scope.OpeningStock.OpeningStockCosts, function (e) {
                        angular.forEach($scope.CostCenters, function (a) {
                            if (e.CostCenter.ParentId == a.CostCenterId) {
                                a.SelectedCostCenterId = e.CostCenter.Id;
                            }
                        })
                    })

                    angular.forEach($scope.OpeningStock.OpeningStockDetails, function (e) {

                        var costs = angular.copy($scope.CostCenters);
                        if (e.OpeningStockCosts.length > 0) {
                            angular.forEach(e.OpeningStockCosts, function (ee) {
                                angular.forEach(costs, function (a) {
                                    if (ee.CostCenter.ParentId == a.CostCenterId) {
                                        a.SelectedCostCenterId = ee.CostCenter.Id;
                                    }
                                })
                                e.CostCenters = angular.copy(costs);
                            })
                        } else {
                            e.CostCenters = angular.copy($scope.CostCenters);
                        }

                    });

                    var length = 10 - $scope.OpeningStock.OpeningStockDetails.length;

                    for (var i = 0; i < length; i++) {

                        var OpeningStockDetails = {
                            Id: 0,
                            Quantity: 0,
                            Value: 0,
                            UnitPrice: 0,
                            UnitId: "",
                            ProductId: "",
                            Remark: "",
                            Product: {},
                            CostCenters: angular.copy($scope.CostCenters),
                        }

                        if ($scope.CompanyProfile.DefaultWarehouseId > 0) {
                            OpeningStockDetails.WarehouseId = $scope.CompanyProfile.DefaultWarehouseId;
                        }

                        $scope.OpeningStock.OpeningStockDetails.push(OpeningStockDetails);
                    }

                    $.LoadingOverlay("hide");

                });
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Opening Stock").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Opening Stock").then(function (response) {
                $scope.PrintSetting = response.data;
            });

            $scope.TableDesign = {};
        $scope.ColumnWidth = null;
        MainService.TableDesignsbyVoucher("Opening Stock").then(function (response) {
            if (response.data != null && response.data != "") {
                $scope.TableDesign = response.data;
                $scope.ColumnWidth = JSON.parse(response.data.ColumnWidth);
            }
        });


            $scope.Warehouses = [];
            MainService.WarehousesInDropdown().then(function (response) {
                $scope.Warehouses = response.data;
            });

            $scope.expand = function () {
                $scope.expandView = !$scope.expandView;
            }

            $scope.VoucherSet = {};
            MainService.VoucherAccountsbyType('Opening Stock').then(function (response) {
                $scope.VoucherSet = response.data;
            })

            $scope.getExtramasters();

             $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];

                if ($scope.ColumnWidth != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.ColumnWidth[key] !== undefined) {
                            cell.style.width = $scope.ColumnWidth[key] + "px";
                        }
                    });
                } else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }
            };

            $scope.init = function () {

                $scope.expandView = false;

                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);


                $scope.Load = false;
                $scope.ViewVal = 0;
                $scope.ErrorText = "";

                $scope.print = {
                    IsPrint: false,
                }

                $scope.OpeningStock = {
                    Date: new Date(),
                    Remark: "",
                    CurrencyId: "",
                    VoucherNo: "",
                    TotalQuantity: 0,
                    OpeningStockDetails: [],

                }



                MainService.getCurrentFinancialYear().then(function (response) {
                    $scope.OpeningStock.Date = new Date(response.data.StartDate);
                });



                $scope.Units = [];
                MainService.UnitsInDropdown().then(function (response) {
                    $scope.Units = response.data;
                });

                $scope.Currencies = [];
                MainService.CurrencyInDropdown().then(function (response) {
                    $scope.Currencies = response.data;
                });

                if ($stateParams.VoucherId > 0) {

                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CostCenters = [];
                        MainService.CostCentersInVoucher("Opening Stock").then(function (response) {
                            $scope.CostCenters = response.data;
                            $scope.loadVoucher($stateParams.VoucherId);
                        });
                    })

                } else {

                    $scope.CompanyProfile = {};
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;

                        if ($scope.CompanyProfile.BaseCurrencyId > 0) {
                            $scope.OpeningStock.CurrencyId = response.data.BaseCurrencyId;
                        }

                        for (var i = 0; i < 10; i++) {

                            var OpeningStockDetails = {
                                Id: 0,
                                Quantity: 0,
                                Value: 0,
                                UnitPrice: 0,
                                UnitId: "",
                                ProductId: "",
                                Remark: "",
                                Product: {},
                            }

                            if ($scope.CompanyProfile.DefaultWarehouseId > 0) {
                                OpeningStockDetails.WarehouseId = $scope.CompanyProfile.DefaultWarehouseId;
                            }

                            $scope.OpeningStock.OpeningStockDetails.push(OpeningStockDetails);
                        }

                        $scope.CostCenters = [];
                        MainService.CostCentersInVoucher("Opening Stock").then(function (response) {
                            $scope.CostCenters = response.data;


                            $scope.AccountNumber = "";
                            MainService.GetNextStockOpeningStock().then(function (response) {
                                $scope.AccountNumber = response.data;
                                angular.forEach($scope.CostCenters, function (cst) {
                                    if (cst.IsAuto) {
                                        var temp = {
                                            Id: 0,
                                            Name: $scope.AccountNumber,
                                            Code: "",
                                        }
                                        cst.CostCenters.push(temp);
                                        cst.SelectedCostCenterId = 0;
                                    }
                                })
                            });

                            angular.forEach($scope.OpeningStock.OpeningStockDetails, function (e) {
                                e.CostCenters = angular.copy($scope.CostCenters);
                            })

                        });

                    })


                }

                 setTimeout(function () {
                    $scope.ReArrangeTable();
                }, 2000);
            }
            $scope.init();


            /////////////////////////////////Product//////////////

            $scope.productsMultiSearchDataSource = {
                type: "odata",
                serverFiltering: true,
                serverPaging: true,
                pageSize: 20,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length == 0) {} else {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    var temp = {
                                        d: {
                                            "results": response.data.Data,
                                            "__count": response.data.Total
                                        }
                                    }
                                    o.success(temp);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error($scope.NetworkErrorLan);
                                });
                            }
                        } else {
                            var temp = {
                                d: {
                                    "results": [],
                                    "__count": 0
                                }
                            }
                            o.success(temp);
                        }
                    }
                }
            };

            $scope.ProductMultiSearchOptions = {
                placeholder: "",
                dataTextField: "Name",
                dataValueField: "Name",
                filter: "contains",
                autoBind: false,
                minLength: 3,
                enforceMinLength: true,
                dropDownWidth: 700,
                dataSource: $scope.productsMultiSearchDataSource,
                columns: [
                    {
                        field: "Name",
                        title: "Name",
                        width: "200px"
                    },
                    {
                        field: "ProductCode",
                        title: "Code",
                        width: "200px"
                    },
                    {
                        field: "BrandName",
                        title: "Brand",
                    },
                    {
                        field: "CountryName",
                        title: "Country",
                    },
                    {
                        field: "HSCode",
                        title: "HS Code",
                    },
                    {
                        field: "Balance",
                        title: "Balance",
                    },
                    {
                        field: "Weight",
                        title: "Weight",
                    },

                ],
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Product = {};
                    $scope.SelectedCE.Product.Name = data.Name;
                    $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                    $scope.SelectedCE.ProductId = data.Id;
                    $scope.SelectedCE.UnitId = data.UnitId;
                    $scope.SelectedCE.UnitPrice = data.PurchasePrice;
                    $scope.SelectedCE.CountryId = data.CountryId;
                    $scope.SelectedCE.BrandId = data.BrandId;
                    $scope.SelectedCE.VATId = data.VATId;
                    $scope.$apply();
                },
            };

            $scope.ProductCodeMultiSearchOptions = {
                placeholder: "",
                dataTextField: "ProductCode",
                dataValueField: "ProductCode",
                filter: "contains",
                autoBind: false,
                minLength: 3,
                enforceMinLength: true,
                dropDownWidth: 700,
                dataSource: $scope.productsMultiSearchDataSource,
                columns: [
                    {
                        field: "ProductCode",
                        title: "Code",
                        width: "200px"
                    },
                    {
                        field: "Name",
                        title: "Name",
                        width: "200px"
                    },
                    {
                        field: "BrandName",
                        title: "Brand",
                    },
                    {
                        field: "CountryName",
                        title: "Country",
                    },
                    {
                        field: "HSCode",
                        title: "HS Code",
                    },
                    {
                        field: "Balance",
                        title: "Balance",
                    },
                    {
                        field: "Weight",
                        title: "Weight",
                    },

                ],
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Product = {};
                    $scope.SelectedCE.Product.Name = data.Name;
                    $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                    $scope.SelectedCE.ProductId = data.Id;
                    $scope.SelectedCE.UnitId = data.UnitId;
                    $scope.SelectedCE.UnitPrice = data.PurchasePrice;
                    $scope.SelectedCE.CountryId = data.CountryId;
                    $scope.SelectedCE.BrandId = data.BrandId;
                    $scope.SelectedCE.VATId = data.VATId;
                    $scope.$apply();
                },
            };



            $scope.ProductAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.productInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };



            $scope.ProductAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Product = {};
                    $scope.SelectedCE.Product.Name = data.Name;
                    $scope.SelectedCE.Product.NameAr = data.NameAr;
                    $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                    $scope.SelectedCE.ProductId = data.Id;
                    $scope.SelectedCE.UnitId = data.UnitId;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };

            $scope.ProductArabicAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "NameAr",
                dataTextField: "NameAr",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Product = {};
                    $scope.SelectedCE.Product.NameAr = data.NameAr;
                    $scope.SelectedCE.Product.Name = data.Name;
                    $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                    $scope.SelectedCE.ProductId = data.Id;
                    $scope.SelectedCE.UnitId = data.UnitId;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };

            $scope.ProductCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "ProductCode",
                dataTextField: "ProductCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Product = {};
                    $scope.SelectedCE.Product.Name = data.Name;
                    $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                    $scope.SelectedCE.ProductId = data.Id;
                    $scope.SelectedCE.UnitId = data.UnitId;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };


            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;

                data.Value = data.Quantity * data.UnitPrice;

                $scope.OpeningStock.TotalQuantity = 0;
                angular.forEach($scope.OpeningStock.OpeningStockDetails, function (e) {
                    if (e.ProductId > 0) {
                        $scope.OpeningStock.TotalQuantity = $scope.OpeningStock.TotalQuantity + e.Quantity;
                    }
                });

                var a = $scope.OpeningStock.OpeningStockDetails.indexOf(data);

                if (($scope.OpeningStock.OpeningStockDetails.length - 1) == a) {

                    var OpeningStockDetails = {
                        Id: 0,
                        Quantity: 0,
                        Value: 0,
                        UnitPrice: 0,
                        UnitId: "",
                        ProductId: "",
                        Remark: "",
                        Product: {},
                    }
                    $scope.OpeningStock.OpeningStockDetails.push(OpeningStockDetails);

                }
            }


            $scope.IsSavePrint = false;

            $scope.SaveVocuher = function (pval) {


                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }

                if ($scope.IsValidFinYear == false) {
                    toastr.info("Operation Not Possible, Current Financial Year Closed.");
                } else {

                    $scope.OpeningStock.DateString = $scope.extractDate($scope.OpeningStock.Date);
                    if ($scope.OpeningStock.Field16 != null) {
                        $scope.OpeningStock.F16DateString = $scope.extractDate($scope.OpeningStock.Field16);
                    }
                    if ($scope.OpeningStock.Field17 != null) {
                        $scope.OpeningStock.F17DateString = $scope.extractDate($scope.OpeningStock.Field17);
                    }
                    if ($scope.OpeningStock.Field18 != null) {
                        $scope.OpeningStock.F18DateString = $scope.extractDate($scope.OpeningStock.Field18);
                    }
                    if ($scope.OpeningStock.Field19 != null) {
                        $scope.OpeningStock.F19DateString = $scope.extractDate($scope.OpeningStock.Field19);
                    }
                    if ($scope.OpeningStock.Field20 != null) {
                        $scope.OpeningStock.F20DateString = $scope.extractDate($scope.OpeningStock.Field20);
                    }

                    var count = 0;
                    angular.forEach($scope.OpeningStock.OpeningStockDetails, function (e) {

                        if (e.ProductId > 0 && e.Price <= 0) {
                            $scope.ErrorText = "Invalid Details ";
                        }
                        if (e.ProductId > 0) {
                            count = 1;
                        }

                        if (e.Field16 != null) {
                            e.F16DateString = $scope.extractDate(e.Field16);
                        }
                        if (e.Field17 != null) {
                            e.F17DateString = $scope.extractDate(e.Field17);
                        }
                        if (e.Field18 != null) {
                            e.F18DateString = $scope.extractDate(e.Field18);
                        }
                        if (e.Field19 != null) {
                            e.F19DateString = $scope.extractDate(e.Field19);
                        }
                        if (e.Field20 != null) {
                            e.F20DateString = $scope.extractDate(e.Field20);
                        }

                        if (e.ProductId > 0) {
                            e.OpeningStockCosts = [];
                            angular.forEach(e.CostCenters, function (a) {
                                if (a.Section == "Body") {
                                    if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                        $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                                    } else {
                                        if (a.SelectedCostCenterId > 0) {
                                            var cst = {
                                                CostCenterId: a.SelectedCostCenterId,
                                            }
                                            e.OpeningStockCosts.push(cst);
                                            console.log(e);
                                        }
                                    }
                                }
                            })
                        }

                    });

                    $scope.OpeningStock.OpeningStockCosts = [];
                    angular.forEach($scope.CostCenters, function (e) {
                        if (e.Section == "Head") {
                            if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                                $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                            } else {
                                if (e.SelectedCostCenterId > 0) {
                                    var cst = {
                                        CostCenterId: e.SelectedCostCenterId,
                                    }
                                    $scope.OpeningStock.OpeningStockCosts.push(cst);
                                }
                            }
                        }
                    })


                    if (count == 0) {
                        $scope.ErrorText = "No Details Found ";
                    }

                    if ($scope.VDesign != null) {
                        if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                            $scope.ErrorText = "Attachment Missing";
                        }
                    }

                    if (!$scope.PageAccessInfo.IsAdd && !$scope.OpeningStock.Id > 0) {
                        toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                    } else if (!$scope.PageAccessInfo.IsEdit && $scope.OpeningStock.Id > 0) {
                        toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");

                    } else {
                        if ($scope.ErrorText == "") {
                            $('#mymodal2').modal('show');
                        }
                    }
                }
            }

            $scope.SaveWithConfirm = function () {
                $scope.Load = true;
                $scope.OpeningStock.VoucherNo = $scope.AccountNumber;
                $scope.OpeningStock.VoucherDocs = $scope.VoucherDocs;

                var VoucherData = angular.copy($scope.OpeningStock);
                angular.forEach(VoucherData.OpeningStockDetails, function (e) {
                    e.CostCenters = [];
                })

                MainService.AddOpeningStock(VoucherData).then(function (response) {
                    if (response.data.Message == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        $('#mymodal2').modal('hide');
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Opening Stock', $scope.AccountNumber);
                        }
                        $scope.init();
                    } else {
                        $scope.Load = false;
                        toastr.warning("Failed");
                    }
                }, function (err) {
                    toastr.error("Error");
                    $scope.Load = false;
                });

            }


            $scope.ViewVouchers = function () {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {
                    viewOpeningStockFactory.select(0).then(function (data) {
                        if (data != null) {

                            MainService.getOpeningStockbyId(data.Id).then(function (response) {
                                if (response.data) {
                                    $scope.UpdateDetails(response.data);
                                }
                            }, function (err) {
                                toastr.error("NetworkError");
                            })

                        }
                    })
                }
            }


            $scope.UpdateDetails = function (data) {

                $scope.OpeningStock = data;
                $scope.AccountNumber = data.VoucherNo;
                $scope.OpeningStock.Date = new Date(data.Date);
                $scope.VoucherDocs = data.VoucherDocs;

                if (data.OpeningStockDetails.length <= 10) {

                    var temp2 = 10 - data.OpeningStockDetails.length;

                    for (var i = 0; i < temp2; i++) {

                        var OpeningStockDetails = {
                            Id: 0,
                            Quantity: 0,
                            Value: 0,
                            UnitPrice: 0,
                            UnitId: "",
                            ProductId: "",
                            Remark: "",
                            WarehouseId: "",
                            Product: {},
                        }

                        $scope.OpeningStock.OpeningStockDetails.push(OpeningStockDetails);
                    }
                }


            }

            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $('#myModal').modal('show');
                }
            }

            $scope.deleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteOpeningStock($scope.OpeningStock.Id).then(function (response) {
                    if (response.data.Message == "Success") {
                        toastr.success("Success");
                        $('#myModal').modal('hide');
                        $state.go("OpeningStock");
                        $scope.init();
                    } else {
                        toastr.warning(response.data.Message);
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })

            }



            $scope.ShowBatchModalEntr = function (data) {
                $scope.ClickedRow = data;
                $scope.ShowBatchModal();
            }

            $scope.ShowBatchModal = function () {

                if ($scope.CompanyProfile.IsProductBatch) {

                    $scope.SelectedCE = $scope.ClickedRow;

                    if ($scope.OpeningStock.Id > 0) {

                        $('#batchmodal').modal('show');
                        $scope.ClickedRow.ManufDate = new Date($scope.ClickedRow.ManufDate);
                        $scope.ClickedRow.ExpiryDate = new Date($scope.ClickedRow.ExpiryDate);

                    } else {

                        if ($scope.ClickedRow.ProductId > 0) {

                            var index = $scope.OpeningStock.OpeningStockDetails.indexOf($scope.ClickedRow);

                            $scope.BatchData = {
                                BatchId: "",
                                ManufDate: null,
                                ExpiryDate: null,
                                BatchNo: "",
                                BatchQty: $scope.ClickedRow.Quantity,
                                AddedQty: $scope.ClickedRow.Quantity,
                                TotalQty: $scope.ClickedRow.Quantity,
                                rowIndex: index,
                            }

                            if ($scope.CompanyProfile.IsAutoBatchNo) {
                                $scope.BatchData.BatchNo = $scope.OpeningStock.VoucherNumber + "00" + index + 1;
                            }

                            $.LoadingOverlay("show", {
                                image: "images/load.gif",
                            });
                            MainService.GetProductBatches($scope.ClickedRow.ProductId).then(function (response) {
                                if (response.data != null) {
                                    $scope.BatchArray = response.data;
                                    $('#batchmodal').modal('show');
                                }
                                $.LoadingOverlay("hide");
                            }, function () {
                                $.LoadingOverlay("hide");
                                toastr.error("Network Error");
                            })
                        } else {
                            toastr.warning("Choose Product");
                        }

                    }

                }

            }

            $scope.AddBatchModal = function () {

                var index = $scope.OpeningStock.OpeningStockDetails.indexOf($scope.ClickedRow);

                if ($scope.BatchData.BatchNo == "") {
                    toastr.error("Enter Batch No");
                } else if ($scope.BatchData.ManufDate == null) {
                    toastr.error("Choose Manuf Date");
                } else if ($scope.BatchData.ExpiryDate == null) {
                    toastr.error("Choose Expiry Date");
                } else if ($scope.BatchData.BatchQty <= 0) {
                    toastr.error("Enter Quantity");
                } else {

                    $scope.BatchArray.push($scope.BatchData);

                    $scope.ClickedRow.BatchNo = $scope.BatchData.BatchNo;
                    $scope.ClickedRow.ManufDate = $scope.BatchData.ManufDate;
                    $scope.ClickedRow.ManufDateString = $scope.extractDate($scope.BatchData.ManufDate);
                    $scope.ClickedRow.ExpiryDate = $scope.BatchData.ExpiryDate;
                    $scope.ClickedRow.ExpiryDateString = $scope.extractDate($scope.BatchData.ExpiryDate);
                    $scope.ClickedRow.BatchQty = $scope.BatchData.BatchQty;
                    $scope.ClickedRow.AddedQty = $scope.BatchData.AddedQty;
                    $scope.ClickedRow.TotalQty = $scope.BatchData.TotalQty;
                    $scope.ClickedRow.BatchId = $scope.BatchData.BatchId;

                    $scope.BatchData = {
                        BatchId: "",
                        ManufDate: null,
                        ExpiryDate: null,
                        BatchNo: "",
                        BatchQty: 0,
                        AddedQty: 0,
                        TotalQty: 0,
                        rowIndex: index,
                    }
                }
            }

            $scope.addToExisting = function (b) {

                var index = $scope.OpeningStock.OpeningStockDetails.indexOf($scope.ClickedRow);

                b.rowIndex = index;
                b.TotalQty = b.BatchQty + b.AddedQty;

                $scope.ClickedRow.BatchNo = b.BatchNo;
                $scope.ClickedRow.ManufDate = b.ManufDate;
                $scope.ClickedRow.ExpiryDate = b.ExpiryDate;
                $scope.ClickedRow.BatchQty = b.BatchQty;
                $scope.ClickedRow.AddedQty = b.AddedQty;
                $scope.ClickedRow.TotalQty = b.TotalQty;
                $scope.ClickedRow.BatchId = b.BatchId;
            }

            $scope.convertBatchDate = function (temp) {
                if (temp == 1) {
                    $scope.ClickedRow.ManufDateString = $scope.extractDate($scope.ClickedRow.ManufDate);
                } else {
                    $scope.ClickedRow.ExpiryDateString = $scope.extractDate($scope.ClickedRow.ExpiryDate);
                }
            }


            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.InsertRow = function () {
                var OpeningStockDetails = {
                    Id: 0,
                    Quantity: 0,
                    Value: 0,
                    UnitPrice: 0,
                    UnitId: "",
                    ProductId: "",
                    Remark: "",
                    WarehouseId: "",
                    Product: {},
                }
                $scope.OpeningStock.OpeningStockDetails.push(OpeningStockDetails);
            }

            $scope.deleteRow = function () {
                var index = $scope.OpeningStock.OpeningStockDetails.indexOf($scope.ClickedRow);
                $scope.OpeningStock.OpeningStockDetails.splice(index, 1);

            }

            $scope.getProductByName = function () {


                $scope.OpeningStock.TotalQuantity = 0;
                angular.forEach($scope.OpeningStock.OpeningStockDetails, function (e) {



                    if (e.ProductCode != null && e.ProductCode != "" && e.ProductCode != "" && e.ProductName !=
                        null && e.ProductName != "" && e.ProductName != "") {

                        $scope.OpeningStock.TotalQuantity = $scope.OpeningStock.TotalQuantity + e.Quantity;

                        angular.forEach($scope.Units, function (a) {
                            if (e.UnitName == a.Name) {
                                e.UnitId = a.Id;
                            }
                        })

                        var temp = {
                            Code: e.ProductCode,
                            Name: e.ProductName,
                        }

                        MainService.getProductByName(temp).then(function (response) {
                            if (response.data) {
                                e.ProductId = response.data.Id;
                                e.Product = response.data;
                            } else {
                                toastr.warning("Product Not Found" + e.AccountName);
                            }
                        }, function () {
                            toastr.error("Network Error");
                        })

                    }

                });

            }

            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                $scope.OpeningStock.OpeningStockDetails = [];

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);

                        angular.forEach(oJS, function (e) {

                            e.ProductCode = e.ProductCode;
                            e.ProductName = e.ProductName;
                            e.ProductId = "";
                            e.Product = {};
                            e.Quantity = parseFloat(e.Quantity);
                            e.UnitPrice = parseFloat(e.UnitPrice);
                            e.Value = parseFloat(e.Value);
                            e.Remark = e.Remarks;
                            e.UnitName = angular.copy(e.Unit);
                            e.Unit = {};
                            e.WarehouseName = e.Warehouse;
                            e.WarehouseId = "";
                            e.Warehouse = null;

                            angular.forEach($scope.Warehouses, function (tt) {
                                if (tt.Name == e.WarehouseName) {
                                    e.WarehouseId = tt.Id;
                                }
                            })

                        });

                        $scope.OpeningStock.OpeningStockDetails = oJS;

                        var length = 10 - $scope.OpeningStock.OpeningStockDetails.length;

                        for (var i = 0; i < length; i++) {

                            var OpeningBalanceDetails = {
                                Id: 0,
                                Quantity: 0,
                                Value: 0,
                                UnitPrice: 0,
                                UnitId: "",
                                ProductId: "",
                                Remark: "",
                                WarehouseId: "",
                                Product: {},
                            }

                            $scope.OpeningStock.OpeningStockDetails.push(OpeningBalanceDetails);
                        }

                        $scope.$apply();
                        $scope.getProductByName();

                    });
                };

                reader.readAsBinaryString(oFile);
            }

            $scope.GetBackOpeningStock = function (type) {
                var temp = 0;
                if ($scope.OpeningStock.Id > 0) {
                    temp = $scope.OpeningStock.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackOpeningStock(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }


            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.OpeningStock.OpeningStockDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });



            /////////////////// Attachment //////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }

            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.OpeningStock.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.OpeningStock.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.OpeningStock.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.OpeningStock.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.OpeningStock.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.DFieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoCompleteDetail(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.D11AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D12AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D13AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D14AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D15AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };



                }]);
